import { API_V1 } from './APIs/APIv1';

// List all global funnels
export const getGlobalFunnels = (params: Record<string, any>) => {
  return API_V1.get('/global-funnels', { params });
};

// Get details of a specific global funnel
export const getGlobalFunnelById = (id: string) => {
  return API_V1.get(`/global-funnels/${id}`);
};

// Add an existing tenant funnel to the global store
export const addFunnelToGlobalStore = (
  funnelId: string,
  data: { description: string; conversionRate: number; creatorName: string }
) => {
  return API_V1.post(`/funnels/${funnelId}/global-store`, data);
};

// Clone a global funnel into the current tenant (apply funnel)
export const applyGlobalFunnel = (
  globalFunnelId: string,
  data: { name: string; linkedinAccount: string }
) => {
  return API_V1.post(`/funnels/apply-global/${globalFunnelId}`, data);
};

// Update a global funnel
export const updateGlobalFunnel = (
  id: string,
  data: { description?: string; conversionRate?: number }
) => {
  return API_V1.put(`/global-funnels/${id}`, data);
};

// Delete a global funnel
export const deleteGlobalFunnel = async (id: string) => {
  const response = await API_V1.delete(`/global-funnels/${id}`);
  return response.data ?? { success: true };
};

// Like a global funnel
export const likeGlobalFunnel = (id: string) => {
  return API_V1.patch(`/global-funnels/${id}/like`, {});
};

// Flow-builder text blocks (system set plus the tenant's overrides)
export const getStoreBlocks = (language: 'de' | 'en') => {
  return API_V1.get('/global-funnels/blocks', { params: { language } });
};

export const updateStoreBlock = (role: string, data: { language: 'de' | 'en'; text: string; scope?: 'tenant' | 'system' }) => {
  return API_V1.put(`/global-funnels/blocks/${role}`, data);
};

export const resetStoreBlock = (role: string, language: 'de' | 'en') => {
  return API_V1.delete(`/global-funnels/blocks/${role}`, { params: { language } });
};
